import { AbstractControl } from '@angular/forms';
import { InputValueType } from '@libs/form/models';
import { ConditionEvaluator } from './condition-evaluator';

export abstract class ConditionEvaluatorBase implements ConditionEvaluator {
  public constructor(
    protected readonly control: AbstractControl,
    protected readonly value: InputValueType,
  ) {
  }

  public abstract evaluate(): boolean;
}
